/*
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-06-24 10:24:03
 * @LastEditors: zhangyuan your_email
 * @LastEditTime: 2024-05-21 15:35:22
 * @FilePath: /report_model_print/src/utils/const/reportMsg.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 报告类型常量文件
 * "no_cert_report"  "toc报告（299）"
"no_cert_report_499"  "toc报告(499)"
"no_cert_report_699"  "toc报告(699)"
"no_cert_report_zhibao"  "toc报告(质保)"
"no_cert_report_haoche"  "toc报告(豪车)"
"no_cert_report_jiaoyifujian"  "toc报告(交易复检)"
"no_cert_report_299_simple"  "toc报告(299三非简版)"
"no_cert_report_double_zhibao_299"  "toc报告(质保双认证报告)"
"no_cert_report_kaien"  "toc报告(凯恩)"
"no_cert_report_retail"  "toc报告(零售)"
"no_cert_report_market"  "toc报告(市场)"
"no_cert_report_299_jiagou"  "toc报告（299加购）"
"no_cert_report_chekuang_299"  "toc报告(无承诺报告)"
"no_cert_report_double_zhibao_jiagou_299"  "质保双认证加购"
"no_cert_report_market_jiagou"  "市场加购"
"no_cert_report_chekuang_jiagou_299"  "车况加购"
"no_cert_report_haoche_jiagou_waiguan" 豪车加购外观
 */
const route = function () {
    const urlParme = window.location.href.split('?')[1].split('&');
    let paramData = {};
    for (let i=0;i<urlParme.length;i++) {
        let item = urlParme[i].split('=');
        let attr = item[0];
        let val = item[1];
        paramData[attr] = val;
    }
    return paramData;
}
// 非准入报告【需求文档：https://souche.yuque.com/268v/lvb5go/xt4rvy】
// 车况
const RpCK  = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('chekuang') >= 0;
}
const Rp299 = function (this: any) {
    return (this.route().templateCode && (this.route().templateCode.indexOf('299') > 0 || this.route().templateCode === 'no_cert_report')) || !this.route().templateCode;
}
const Rp499 = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('499') > 0;
}
const Rp699 = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('699') > 0;
}
const Rp799 = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('799') > 0;
}
// 豪车
const RpHC = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('haoche') > 0;
}
// 豪车加购
const RpHCJG = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('haoche_jiagou') > 0;
}
// 双认证
const RpSRZ = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('double_zhibao') > 0;
}
// 复检
const RpFJ = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('jiaoyifujian') > 0;
}
// 质保
const RpZB = function (this: any) {
    return this.route().templateCode && this.route().templateCode === 'no_cert_report_zhibao';
}
// 加购
const RpJG = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('jiagou') > 0;
}
// 零售
const RpLS = function (this: any) {
    return this.route().templateCode && (this.route().templateCode.indexOf('retail') > 0 || this.route().channelType === 'lingshou');
}
// 市场
const RpSC = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('market') > 0;
}
// 凯恩
const RpKE = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('kaien') > 0;
}
// 瑞城
const RpRC = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('ruicheng') >= 0;
}
// 瑞城Auth
const RpRCAUTH = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('ruicheng_auth') >= 0;
}
// 中汽研报告_标准版
const RpZQYB = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('caeri_ulti') > 0;
}
// 中汽研报告_升级版
const RpZQYS = function (this: any) {
    return this.route().templateCode && this.route().templateCode.indexOf('caeri_pro') > 0;
}


export default {
    route,
    RpCK,
    Rp299,
    Rp499,
    Rp699,
    Rp799,
    RpHC,
    RpHCJG,
    RpSRZ,
    RpFJ,
    RpZB,
    RpJG,
    RpLS,
    RpSC,
    RpKE,
    RpRC,
    RpRCAUTH,
    RpZQYB,
    RpZQYS
}